import { ChangeDetectionStrategy, Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'no-user-list-item',
    template: `
        <div class="collab-list-item-container user-img-show-indicator">
            <div class="collab-list-item-inner">
                <p translate class="collab-list-item-collab-name fx-ellipsis body">{{ translate.get( "SHARE.NO_TEAM_USERS_FOUND" ) | async }}</p>
            </div>
        </div>
    `,
    styleUrls: [ './user-list-item/user-list-item.scss' ],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
/**
 * This component is used to encapsulate functionality such as
 * displaying and removing a collaborator from the collaborator
 * list in the project / diagram share window. A collabortator
 * can be added by using the <collaborator-item></collaborator-item>
 * selector.
 */
export class NoUserListItem {

    /* istanbul ignore next */
    constructor( public translate: TranslateService ) {}
}
